/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-nav': {
    width: 16,
    height: 16,
    viewBox: '0 0 18 18',
    data: '<rect pid="0" y="8" width="18" height="2" rx="1" ry="1"/><rect pid="1" y="3" width="18" height="2" rx="1" ry="1"/><rect pid="2" y="13" width="18" height="2" rx="1" ry="1"/>'
  }
})
